export default __webpack_public_path__ + "static/media/video.c69a8324.svg";